import React from 'react';
import { cn } from '@/lib/utils';
import logoSrc from '@/assets/vergo-v-logo.png';

interface VergoLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16',
};

/**
 * Vergo V monogram. The source asset is dark; we invert it on dark
 * backgrounds so it stays legible in both light and dark themes.
 */
export const VergoLogo: React.FC<VergoLogoProps> = ({ className, size = 'md' }) => {
  return (
    <img
      src={logoSrc}
      alt="Vergo"
      width={64}
      height={64}
      fetchPriority="high"
      decoding="async"
      className={cn(
        sizeClasses[size],
        'object-contain select-none dark:invert',
        className,
      )}
    />
  );
};

export default VergoLogo;
